import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import MDTypography from "components/MDTypography";
import { useSKUOptions } from "hooks/useQueryHook";
import { useState } from "react";
import { SelectField } from "ui-components/Form";

import { Text, DatePickerField } from "ui-components/Form";

function KitSKUDetailInfo({ formRender, control, errors, setValue, watch, customerCode }) {
  const [skuOptions, setSKUOptions] = useState([]);

  const [skuCode, quantity] = watch(["skuCode", "quantity"]);

  useSKUOptions({
    customerCode,
    onSuccess: (data) => {
      setSKUOptions(
        data.data.data.map((x) => ({
          label: x.skuCode,
          value: x.skuCode,
          description: x.descriptions1,
        }))
      );
    },
  });

  const onSKUChange = (e, option) => {
    setValue("skuCode", option.value);
    setValue("skuDescription", option.description);
  };

  function renderFn(property, index, length) {
    const { xs, disabled, edit, ...data } = property;
    //custom xs
    const xs2 = xs ? xs : 12 / length;
    const fieldProps = {
      ...data,
      control,
      errors,
      ...(disabled && { disabled }),
    };

    let renderField;
    if (data.type === "text" || data.type === "number") {
      renderField = <Text field={fieldProps} />;
    } else if (data.type === "date") {
      renderField = <DatePickerField field={fieldProps} />;
    } else if (data.type === "select") {
      renderField = (
        <SelectField
          field={fieldProps}
          options={data.name === "skuCode" && skuOptions}
          onChange={onSKUChange}
          control={control}
          errors={errors}
        />
      );
    }
    return (
      <Grid key={index} item xs={xs2}>
        {renderField}
      </Grid>
    );
  }

  return (
    <MDBox>
      <MDTypography mt={1.625} mb={2} color="info" variant="h5">
        SKU&nbsp;Kit&nbsp;Detail
      </MDTypography>
      <MDBox mt={1.625}>
        {formRender.map((rows, i) => (
          <Grid container spacing={3} key={i}>
            {rows.map((row, index) => renderFn(row, index, rows.length))}
            <Grid key={"add-button"} item xs={3}>
              <MDBox mt={2} width="100%" sx={{ marginTop: "0px" }}>
                <MDButton
                  type="submit"
                  variant="gradient"
                  color="info"
                  disabled={skuCode === null || quantity === null || quantity <= 0}
                >
                  Add
                </MDButton>
              </MDBox>
            </Grid>
          </Grid>
        ))}
      </MDBox>
    </MDBox>
  );
}

export default KitSKUDetailInfo;
